import { useEffect, useState } from "react";

const SCROLL_TO_TOP_OFFSET = 40;

const DEFAULT_PRODUCT_ITEM_SELECTOR =
  ":scope > li.products_list_item, :scope > li.products_list_item-two, :scope > li.products_list_item-four, :scope > li.products_list_item-five";

const getProductsPerRow = (columnCountWidth, isTabletOrMobile) => {
  if (isTabletOrMobile) return 2;
  if (columnCountWidth === 2) return 2;
  if (columnCountWidth === 4) return 4;
  if (columnCountWidth === 5) return 5;
  return 3;
};

export function useProductsScrollToTop(
  productsListRef,
  columnCountWidth,
  productCount,
  { isTabletOrMobile = false, productItemSelector = DEFAULT_PRODUCT_ITEM_SELECTOR } = {}
) {
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const itemsPerRow = getProductsPerRow(columnCountWidth, isTabletOrMobile);
    const hasMultipleRows = productCount > itemsPerRow;

    if (!hasMultipleRows) {
      setShowScrollToTop(false);
      return undefined;
    }

    const onScroll = () => {
      const list = productsListRef.current;
      if (!list) return;

      const productItems = list.querySelectorAll(productItemSelector);

      if (productItems.length <= itemsPerRow) {
        setShowScrollToTop(false);
        return;
      }

      const firstRowItems = Array.from(productItems).slice(0, itemsPerRow);
      const firstRowBottom = Math.max(
        ...firstRowItems.map((item) => item.getBoundingClientRect().bottom)
      );

      setShowScrollToTop(firstRowBottom <= SCROLL_TO_TOP_OFFSET);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [productsListRef, columnCountWidth, productCount, isTabletOrMobile, productItemSelector]);

  return { showScrollToTop, scrollToTop };
}
